// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import classes from "./CustomSlider.module.css";
// import "./CustomSlider.css";

// const settings = {
//   infinite: true,
//   speed: 500,
//   slidesToShow: 1,
//   slidesToScroll: 1,
// };

// const CustomSlider = (props) => {
//   return (
//     <Slider className={classes.slider} {...settings}>
//       {props.children}
//     </Slider>
//   );
// };

// export default CustomSlider;

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import classes from "./CustomSlider.module.css";
import "./CustomSlider.css";
import { useEffect, useRef } from "react";

const defaultSettings = {
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
};

/**
 * WCAG 2.1 fix — aria-hidden + focusable elements (WCAG 1.3.1 / 4.1.2)
 *
 * react-slick renders cloned slides (for infinite loop) with aria-hidden="true"
 * but keeps focusable children inside them reachable by keyboard. This violates
 * WCAG SC 1.3.1 / 4.1.2: "Ensure Focusable Elements Are Not Contained Within
 * aria-hidden Elements."
 *
 * Fix strategy:
 *  1. accessibility: true  — lets slick own aria-hidden on slide wrappers.
 *  2. After every render/slide change we query ALL .slick-slide elements,
 *     and for any that carry aria-hidden="true" we set tabindex="-1" and
 *     aria-hidden="true" on every focusable descendant so they are removed
 *     from the tab order and the accessibility tree.
 *  3. When a slide becomes the active one (aria-hidden removed by slick) we
 *     restore the attributes we changed.
 */

const FOCUSABLE_SELECTOR =
  "a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), " +
  'textarea:not([disabled]), [tabindex]:not([tabindex="-1"]), [contenteditable="true"]';

const syncSlideAccessibility = (containerEl) => {
  if (!containerEl) return;
  containerEl.querySelectorAll(".slick-slide").forEach((slide) => {
    const isHidden = slide.getAttribute("aria-hidden") === "true";
    slide.querySelectorAll(FOCUSABLE_SELECTOR).forEach((el) => {
      if (isHidden) {
        // Stash original tabindex so we can restore it
        if (!el.hasAttribute("data-orig-tabindex")) {
          el.setAttribute(
            "data-orig-tabindex",
            el.getAttribute("tabindex") ?? "__none__",
          );
        }
        el.setAttribute("tabindex", "-1");
      } else {
        // Restore original tabindex
        const orig = el.getAttribute("data-orig-tabindex");
        if (orig !== null) {
          if (orig === "__none__") {
            el.removeAttribute("tabindex");
          } else {
            el.setAttribute("tabindex", orig);
          }
          el.removeAttribute("data-orig-tabindex");
        }
      }
    });
  });
};

const CustomSlider = (props) => {
  const wrapperRef = useRef(null);

  const settings =
    "settings" in props
      ? { ...defaultSettings, ...props.settings }
      : defaultSettings;

  const a11ySettings = {
    ...settings,
    // accessibility:true enables slick's own keyboard handling (arrow keys)
    accessibility: true,
    afterChange: (current) => {
      syncSlideAccessibility(wrapperRef.current);
      if (typeof settings.afterChange === "function")
        settings.afterChange(current);
    },
  };

  // Run after every render so cloned slides are fixed on mount too
  useEffect(() => {
    const id = setTimeout(() => syncSlideAccessibility(wrapperRef.current), 0);
    return () => clearTimeout(id);
  });

  return (
    <div ref={wrapperRef}>
      <Slider className="slick-slider" {...a11ySettings}>
        {props.children}
      </Slider>
    </div>
  );
};

export default CustomSlider;
